import { Component, OnInit } from '@angular/core';
import { PortalSettingsService } from '../../core/services/portal-settings.service';
import { EventService } from 'src/app/core/services/event.service';
import { HomeService } from '../../pages/home/services/home.service';
import { UtilityService } from '../../core/services/utility.service';

@Component({
  selector: 'app-onboarding-layout',
  templateUrl: './onboarding-layout.component.html',
  styleUrls: ['./onboarding-layout.component.css']
})
export class OnboardingLayoutComponent implements OnInit {
  portalSettings: any;
  isSafari: boolean = false;
  isMobileIos: any;
  showLogout: boolean = false;
  showAT: boolean = false;
  showON: boolean = false;
  oNLogoCo: number;
  portalName: string;
  logoUrl: string;

  constructor(portalSettingsService: PortalSettingsService, private homeService: HomeService, private eventService: EventService, private utilityService: UtilityService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.oNLogoCo = this.portalSettings.OnboardingLogoCo.ConfigValue;
    this.isSafari = this.utilityService.checkSafari();
    this.isMobileIos = navigator.userAgent.match(/(iPad|iPhone|iPod touch);.*(OS 7_|OS 8_|OS 9_|OS 10_|OS 11_|OS 12_\d)/i);
    if (this.isMobileIos != null && this.isSafari) {
      $('#NavBar').addClass('mobileSafari');
    }
    this.logoUrl = "/Company/GetLogo?co=" + this.oNLogoCo + "&size=S";
    if (window.location.pathname.toLowerCase().indexOf("welcome") == -1) {
      this.showLogout = true;
    }
    this.eventService.on('ISAT', () => {
      this.showAT = true;
      this.showON = false;
    });
    this.eventService.on('ISON', () => {
      this.showAT = false;
      this.showON = true;
    });
    this.getPortalName();
  }

  getPortalName() {
    this.homeService.getPortalName(this.oNLogoCo).then((response) => {
      this.portalName = response == "" ? null : response;
    });
  }
}
